import React, {useEffect} from "react";
import { Box } from "rebass";
import { AppRouter } from "./Router";
import { AppContexts } from "./Contexts";
import { ThemeProvider } from "emotion-theming";
import { QueryClient, QueryClientProvider } from 'react-query';
import { theme } from "./Theme";
import axios from "axios";
import "typeface-open-sans";
import { Messages } from "./Components";
import {Switch} from "react-router-dom";
import { queryClient } from './lib/react-query';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.withCredentials = true;


function App() {
  useEffect(()=>{
    document.body.style.overflow = "hidden"
  }, [])

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Box paddingLeft={[0, 0, 0]} paddingRight={[0, 0, 0]}>
          <AppContexts>
            <Messages />
            <AppRouter />
          </AppContexts>
        </Box>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
